/**
 * search — pure ranking/filter for the Start menu over the flattened app list
 * (each app is { key, title, section, path }). Kept pure so it's unit-testable.
 */

// Does `needle` appear as an in-order subsequence of `hay`? (fuzzy match)
const isSubsequence = (needle, hay) => {
  let i = 0;
  for (let j = 0; j < hay.length && i < needle.length; j += 1) {
    if (hay[j] === needle[i]) i += 1;
  }
  return i === needle.length;
};

// Higher is better; -1 means "no match".
export const scoreApp = (app, query) => {
  const q = String(query || "").trim().toLowerCase();
  if (!q) return 0;
  const title = String(app.title || "").toLowerCase();
  const section = String(app.section || "").toLowerCase();
  if (title === q) return 100;
  if (title.startsWith(q)) return 85;
  if (title.includes(q)) return 70;
  if (section.startsWith(q)) return 50;
  if (section.includes(q)) return 40;
  if (isSubsequence(q, title)) return 25;
  if (isSubsequence(q, section)) return 15;
  return -1;
};

// Returns matching apps, best first. Empty query → all apps (original order).
export const searchApps = (apps, query) => {
  const q = String(query || "").trim();
  if (!q) return [...apps];
  return apps
    .map((app, i) => ({ app, i, score: scoreApp(app, q) }))
    .filter((x) => x.score >= 0)
    .sort((a, b) => b.score - a.score || a.i - b.i) // stable on ties
    .map((x) => x.app);
};
